import { colors } from "assets/styles/colors";
import { Grid } from "assets/styles/globalStyles";
import { FontSizes } from "utils/enums";
import styled from "styled-components";

export const FounderWrapper = styled.div`
    padding-top:145px;
    position:relative;
    min-height:100vh;
    width:100%
    .___comn_txt{
        p{
            margin:0;
        }
    }
    .__founder{
        p{
            -webkit-line-clamp: 5;
            -webkit-box-orient: vertical;
            display: -webkit-box;
            flex: 1 1;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        h2, img{
            display: none;
        }
    }
`
export const OtherEvApps = styled.div`
    grid-gap: 25px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
    margin: 20px 0;
    width: 100%;
    .__single_app{
        cursor:pointer;
        text-align:center;
        img{
            border-radius: 20px;
            height: 70px;
            width: 70px;
            object-fit:cover;
        }
        h6{
            font-weight:400;
            margin:0;
            margin-top:10px;
        }

    }
`